import clsx from 'clsx'
import React from 'react'
import { displayUsdAmount } from 'src/common/utils/formatters/number'

interface BaseBalanceCardProps {
  loading?: boolean
  className?: string
  children?: React.ReactNode
  title: string
  totalBalanceInUsd: Big
  rwaBalanceInUsd: Big
  cryptoBalanceInUsd: Big
  goldBalanceInUsd: Big
}

const BaseBalanceCard: React.FC<BaseBalanceCardProps> = ({
  loading,
  className,
  title,
  totalBalanceInUsd,
  rwaBalanceInUsd,
  cryptoBalanceInUsd,
  goldBalanceInUsd,
}) => {
  return (
    <div
      className={clsx('paper p-2 md:p-4 w-full h-22', className, {
        'flex justify-center items-center': loading,
      })}
    >
      {loading ? (
        <div className='loader size-10' />
      ) : (
        <>
          <h4 className='typo-label2 font-medium mb-1'>{title}</h4>
          <h3 className='typo-title2 font-bold lg:typo-heading1 lg:font-bold'>
            {displayUsdAmount(totalBalanceInUsd)} USD
          </h3>

          {/* <ul className='flex flex-col gap-2'>
            <li className='flex gap-2 justify-between typo-label2'>
              <span>Stocks & Bonds</span>{' '}
              <span>{displayUsdAmount(rwaBalanceInUsd)} USD</span>
            </li>
            <li className='flex gap-2 justify-between typo-label2'>
              <span>Crypto</span>{' '}
              <span>{displayUsdAmount(cryptoBalanceInUsd)} USD</span>
            </li>
            <li className='flex gap-2 justify-between typo-label2'>
              <span>Gold</span>{' '}
              <span>{displayUsdAmount(goldBalanceInUsd)} USD</span>
            </li>
          </ul> */}
        </>
      )}
    </div>
  )
}

export default BaseBalanceCard
